
import { DynamicFormItemProps } from "../trade/components/DynamicForm/DynamicForm"


export const formItems1: DynamicFormItemProps[] = [
    {fieldLabel: '转入地址', fieldName: 'receivingAddress', fieldType: 'CopyIcon'},
    {fieldLabel: '购买V币金额', fieldName: 'amount', fieldType: 'BalanceVB', readOnly: true},
    {fieldLabel: '应付USDT', fieldName: 'copeAmount', fieldType: '2', readOnly: true, extra: <span style={{color: '#01B14E'}}>USDT</span>},
    {fieldLabel: '实付USDT', fieldName: 'actualAmount', fieldType: '2', readOnly: true, extra: <span style={{color: '#01B14E'}}>USDT</span> },
    {fieldLabel: '到账V币金额', fieldName: 'depositAmount', fieldType: 'BalanceVB', readOnly: true},
    {fieldLabel: 'USDT价格', fieldName: 'feeRate', fieldType: '2', readOnly: true, extra: <span style={{color: '#01B14E'}}>￥</span> },
  ]

  export const formItemsOut: DynamicFormItemProps[] = [
    {fieldLabel: '收U地址', fieldName: 'receivingAddress', fieldType: 'CopyIcon'},
    {fieldLabel: '出售V币金额', fieldName: 'amount', fieldType: 'BalanceVB', readOnly: true},
    {fieldLabel: '应得USDT', fieldName: 'copeAmount', fieldType: '2', readOnly: true, extra: <span style={{color: '#01B14E'}}>USDT</span>},
    {fieldLabel: 'USDT价格', fieldName: 'feeRate', fieldType: '2', readOnly: true, extra: <span style={{color: '#01B14E'}}>￥</span> },
    {fieldLabel: '备注', fieldName: 'remark',placeholder: '暂无', fieldType: '1', readOnly: true },
  ]
  
  export const formItems: DynamicFormItemProps[] = [
    {fieldLabel: '订单号', fieldName: 'orderNo', fieldType: 'CopyIcon'},
  ]
  

